import { Ty } from '@cotera/era';
import { DG } from '@cotera/sdk/core';
import { createContext, useContext } from 'react';

type ErodSchemaFormMeta = {
  lintingParser: DG.Graph.RelativeParser;
  colRefAttrs: Record<string, Ty.ExtendedAttributeType>;
};

const ErodSchemaFormMetaContext = createContext<ErodSchemaFormMeta>({
  lintingParser: new DG.Graph.GraphRelativeParser({}),
  colRefAttrs: {},
});

export const ErodSchemaFormMetaProvider = ErodSchemaFormMetaContext.Provider;
export const useErodSchemaFormMeta = () =>
  useContext(ErodSchemaFormMetaContext);
